const TECHNICAL_CONTOUR_HOSTNAMES = new Set([
  'preprod.moy-gorod.su',
]);

export const TECHNICAL_CONTOUR_ALLOWED_ROUTE_PREFIXES = [
  '/helpdesk',
  '/helpdesk/system-tasks',
  '/login',
  '/feedback/max',
  '/max/feedback',
] as const;

export const TECHNICAL_CONTOUR_FORBIDDEN_ROUTE_PREFIXES = [
  '/dashboard',
  '/messages',
  '/tickets',
  '/map',
  '/heatmap-lab',
  '/export',
  '/analytic',
  '/sources',
  '/roles',
  '/tenant-settings',
  '/parser',
  '/dev/llm-compare',
] as const;

export const isTechnicalContourHostname = (hostname?: string | null): boolean => {
  const normalized = String(
    hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')
  )
    .trim()
    .toLowerCase();
  return TECHNICAL_CONTOUR_HOSTNAMES.has(normalized);
};

export const isTechnicalContour = (): boolean => isTechnicalContourHostname();

export const getTechnicalContourAllowedRoutes = (): string[] => [...TECHNICAL_CONTOUR_ALLOWED_ROUTE_PREFIXES];

export const getTechnicalContourForbiddenRoutes = (): string[] => [...TECHNICAL_CONTOUR_FORBIDDEN_ROUTE_PREFIXES];

export const isTechnicalContourAllowedPath = (pathname?: string | null): boolean => {
  const normalized = String(pathname ?? '').trim() || '/';
  if (normalized === '/') return false;
  return TECHNICAL_CONTOUR_ALLOWED_ROUTE_PREFIXES.some((prefix) =>
    normalized === prefix || normalized.startsWith(`${prefix}/`)
  );
};

